class MainSearch extends SearchForm {
  constructor() {
    super();
    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
    this.searchResult = document.querySelector('#main-search-result');
    this.loadingSpinner = this.querySelector('.main-search-loading_spinner ')
    this.mainSearchInput = this.querySelector('input[type="search"]')

    this.setupEventListeners();
    this.mainSearchInput.addEventListener('input', this.updateSearchResults.bind(this))
  }

  setupEventListeners() {
    let allSearchForms = [];
    this.allSearchInputs.forEach((input) => allSearchForms.push(input.form));
    this.input.addEventListener("focus", this.onInputFocus.bind(this));
    if (allSearchForms.length < 2) return;
    allSearchForms.forEach((form) => form.addEventListener("reset", this.onFormReset.bind(this)));
    this.allSearchInputs.forEach((input) => input.addEventListener("input", this.onInput.bind(this)));
  }

  onFormReset(event) {
    super.onFormReset(event);
    if (super.shouldResetForm()) {
      this.keepInSync("", this.input);
    }
    this.updateSearchResults(this.mainSearchInput)
  }

  onInput(event) {
    const target = event.target;
    this.keepInSync(target.value, target);
  }

  onInputFocus() {
    const isSmallScreen = window.innerWidth < 750;
    if (isSmallScreen) {
      this.scrollIntoView({ behavior: "smooth" });
    }
  }

  keepInSync(value, target) {
    this.allSearchInputs.forEach((input) => {
      if (input !== target) {
        input.value = value;
      }
    });
  }

  //  get the search results on input 
  async updateSearchResults(event) {

    this.loadingSpinner.classList.remove('tw-hidden')
    this.searchResult.classList.add('tw-hidden')


    const target = event.target;
    clearTimeout(this._debounceTimer);

    this._debounceTimer = setTimeout(async () => {
      try {
        if (!target.value) {
          document.querySelector('#main-search-result').innerHTML = '';
          this.loadingSpinner.classList.add('tw-hidden')
          this.searchResult.classList.add('tw-hidden')
          return;
        }

        const url = `/search?options%5Bprefix%5D=last&q=${encodeURIComponent(target.value)}`;

        const res = await fetch(url);
        const text = await res.text();

        const doc = new DOMParser().parseFromString(text, 'text/html');
        const newHtml = doc.querySelector('#main-search-result');

        if (newHtml) {
          document.querySelector('#main-search-result').innerHTML = newHtml.innerHTML;
          this.loadingSpinner.classList.add('tw-hidden')
          this.searchResult.classList.remove('tw-hidden')
          const searchUrl = `?q=${encodeURIComponent(target.value)}&options[prefix]=last`;
          window.history.pushState({}, '', url);
        }

      } catch (err) {
        this.loadingSpinner.classList.add('tw-hidden')
        window.history.pushState({}, '','/search');
        console.error('Search fetch failed:', err);
      }
    }, 300);
  }
}

customElements.define("main-search", MainSearch);
